import * as React from "react";

const SvgIcnEmpty = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 64 64" {...props}>
        <g fill="none" fillRule="evenodd" stroke="currentColor">
            <path d="M54 18.278H10c-.414 0-.79.168-1.06.44a1.49 1.49 0 00-.44 1.06v5.5h47v-5.5c0-.414-.168-.79-.44-1.06a1.49 1.49 0 00-1.06-.44zm1.5 7.111h-47V54c0 .414.168.79.44 1.06.27.272.646.44 1.06.44h44c.414 0 .79-.168 1.06-.44.272-.27.44-.646.44-1.06V25.389z" />
            <path strokeLinecap="round" d="M30.222 39.556h19.556" />
            <rect width={13.222} height={13.222} x={13.833} y={34.278} rx={1} />
            <path
                strokeLinecap="round"
                d="M30.222 36.889h8.889M13.778 21.778h17.778M50.092 20.76l1.886 1.885M50.092 22.645l1.886-1.886M30.222 42.222h19.556m-19.556 2.667h16"
            />
            <circle cx={20.444} cy={39.556} r={2.722} />
            <path d="M22.889 44.056H18c-.414 0-.79.167-1.06.439-.272.271-.44.646-.44 1.06V47.5h7.889v-1.944c0-.415-.168-.79-.44-1.061a1.49 1.49 0 00-1.06-.44z" />
            <path d="M59.997.5H4.003c-.966 0-1.842.393-2.476 1.027A3.49 3.49 0 00.5 4.003v55.994c0 .966.393 1.842 1.027 2.476A3.493 3.493 0 004.003 63.5h55.994c.966 0 1.842-.393 2.476-1.027a3.493 3.493 0 001.027-2.476V4.003c0-.966-.393-1.842-1.027-2.476A3.49 3.49 0 0059.997.5zM.444 10.222h63.112" />
            <path d="M5.333 4.056c-.353 0-.672.143-.903.374a1.275 1.275 0 00.903 2.181 1.275 1.275 0 001.278-1.278 1.273 1.273 0 00-1.278-1.277zm5.334 0a1.275 1.275 0 00-1.278 1.277 1.275 1.275 0 001.278 1.278 1.273 1.273 0 001.277-1.278c0-.353-.143-.672-.374-.903a1.273 1.273 0 00-.903-.374zm5.333 0a1.277 1.277 0 100 2.555 1.277 1.277 0 100-2.555z" />
        </g>
    </svg>
);

export default SvgIcnEmpty;
